import {ActionContext, Module} from "vuex";
import {RootState} from "@/store/index";
import {ForwardingAgency, forwardingAgencyApi,} from "@/api/misc";

export interface ForwardingAgencyState {
  forwardingAgency: ForwardingAgency[];
}

const forwardingAgencyModule: Module<ForwardingAgencyState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      forwardingAgency: [] as ForwardingAgency[],
    } as ForwardingAgencyState),
  mutations: {
    setForwardingAgency(state: ForwardingAgencyState, forwardingAgency: ForwardingAgency[]): void {
      state.forwardingAgency = forwardingAgency;
    },
  },
  actions: {
    async listAll(
      context: ActionContext<ForwardingAgencyState, RootState>
    ): Promise<void> {
      if (!context.state.forwardingAgency || context.state.forwardingAgency.length === 0) {
        context.commit("setForwardingAgency", await forwardingAgencyApi.listForwardingAgency());
      }
    },
    async addForwardingAgency(
      context: ActionContext<ForwardingAgencyState, RootState>,
      forwardingAgency: ForwardingAgency
    ): Promise<void> {
      await forwardingAgencyApi.addForwardingAgency(forwardingAgency);
      context.commit("setForwardingAgency",  await forwardingAgencyApi.listForwardingAgency());
    },
    async editForwardingAgency(
      context: ActionContext<ForwardingAgencyState, RootState>,
      forwardingAgency: ForwardingAgency
    ): Promise<void> {
      if (forwardingAgency.id) {
        await forwardingAgencyApi.editForwardingAgency(forwardingAgency);
        context.commit("setForwardingAgency", await forwardingAgencyApi.listForwardingAgency());
      }
    },
    async removeForwardingAgency(
      context: ActionContext<ForwardingAgencyState, RootState>,
      forwardingAgency: ForwardingAgency
    ): Promise<void> {
      if (forwardingAgency.id) {
        await forwardingAgencyApi.deleteForwardingAgency(forwardingAgency);
        context.commit("setForwardingAgency", await forwardingAgencyApi.listForwardingAgency());
      }
    },
  },
};

export default forwardingAgencyModule;
